import { render, staticRenderFns } from "./bc_search_menu.vue?vue&type=template&id=48e8b6c1&"
import script from "./bc_search_menu.vue?vue&type=script&lang=js&"
export * from "./bc_search_menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports